import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Divider, Grid, TextField } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';

import { Button, SubmitButton } from '../../../../../common/button';
import { createCustomerBlockadeRegistryNotificationData, getCustomerNotificationData } from '../../../../../../core/utils/notification_utils';
import { ApiRequestStatusEnum } from '../../../../../../core/enums/common/api';
import useNotification from '../../../../../../core/hooks/use_notification';
import { createCustomerBlockadeRegistryAction, createCustomerBlockadeRegistryState } from '../../../../../../features/customer/create_customer_blockade_registry';
import { getCustomerAction } from '../../../../../../features/customer/get_customer';

const CreateCustomerBlockadeRegistryDialog = ({ customerId }) => {
    const dispatch = useDispatch();
    const { showNotification, showErrorMessage } = useNotification();
    const reasonRef = useRef(null);

    const createCustomerBlockadeRegistry = useSelector(createCustomerBlockadeRegistryState);

    const [open, setOpen] = useState(false);

    const onClose = () => setOpen(false);

    const onCreateCustomerBlockadeRegistry = () => {
        dispatch(createCustomerBlockadeRegistryAction({ customerId, reason: reasonRef?.current?.value }))
            .then(response => {
                showNotification(createCustomerBlockadeRegistryNotificationData(response));

                if (response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED) {
                    dispatch(getCustomerAction(customerId))
                        .then(response => showErrorMessage(getCustomerNotificationData(response)));
                    onClose();
                }
            });
    };

    return (
        <>
            <Button onClick={ () => setOpen(true) }>
                Dodaj blokadę
            </Button>

            <Dialog PaperProps={ { sx: { maxHeight: 800 } } } open={ open } onClose={ onClose } fullWidth maxWidth="sm">
                <DialogTitle sx={ { fontWeight: 600, pb: 1 } }>Dodaj blokadę</DialogTitle>

                <Divider/>

                <DialogContent sx={ { py: 3 } }>
                    <Grid container spacing={ 3 }>
                        <Grid item xs={ 12 }>
                            <TextField
                                name="reason"
                                label="Powód blokady"
                                fullWidth
                                size="small"
                                inputRef={ reasonRef }
                                required
                            />
                        </Grid>
                    </Grid>
                </DialogContent>

                <Divider sx={ { mt: 1 } }/>

                <DialogActions sx={ { px: 3, py: 2, gap: 1 } }>
                    <Button variant="outlined" onClick={ onClose }>Zamknij</Button>
                    <SubmitButton onClick={ onCreateCustomerBlockadeRegistry } isLoading={ createCustomerBlockadeRegistry?.loading }>Zapisz</SubmitButton>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default CreateCustomerBlockadeRegistryDialog;